/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { modelKeysUpsertKey } from "../funcs/modelKeysUpsertKey.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ModelProviderKey } from "../models/components/modelproviderkey.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  UpsertModelProviderKeyRequest,
  UpsertModelProviderKeySecurity,
} from "../models/operations/upsertmodelproviderkey.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type UpsertModelProviderKeyMutationVariables = {
  request: UpsertModelProviderKeyRequest;
  security?: UpsertModelProviderKeySecurity | undefined;
  options?: RequestOptions;
};

export type UpsertModelProviderKeyMutationData = ModelProviderKey;

export type UpsertModelProviderKeyMutationError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * upsertKey modelKeys
 *
 * @remarks
 * Create or replace the model provider key for a slot. The key is validated with the provider, then stored encrypted.
 */
export function useUpsertModelProviderKeyMutation(
  options?: MutationHookOptions<
    UpsertModelProviderKeyMutationData,
    UpsertModelProviderKeyMutationError,
    UpsertModelProviderKeyMutationVariables
  >,
): UseMutationResult<
  UpsertModelProviderKeyMutationData,
  UpsertModelProviderKeyMutationError,
  UpsertModelProviderKeyMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildUpsertModelProviderKeyMutation(client, options),
    ...options,
  });
}

export function mutationKeyUpsertModelProviderKey(): MutationKey {
  return ["@gram/client", "modelKeys", "upsertKey"];
}

export function buildUpsertModelProviderKeyMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: UpsertModelProviderKeyMutationVariables,
  ) => Promise<UpsertModelProviderKeyMutationData>;
} {
  return {
    mutationKey: mutationKeyUpsertModelProviderKey(),
    mutationFn: function upsertModelProviderKeyMutationFn({
      request,
      security,
      options,
    }): Promise<UpsertModelProviderKeyMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(modelKeysUpsertKey(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}
